<template>
  <b-modal
    id="addBank"
    class="mc-modal"
    :title="
      formEdit
        ? $t('setting.list.company.form.changeAccount')
        : $t('setting.list.company.form.addAccount')
    "
    size="lg"
    centered
    scrollable
    @hidden="resetModal"
  >
    <FormulateForm ref="bankAccountRef" v-model="bankAccounts" @submit="toSaveBank">
      <b-row>
        <b-col md="6">
          <div class="mb-3 form-group">
            <FormulateInput
              type="select-resourceful-v2"
              name="bankName"
              :placeholder="$t('setting.list.company.placeholder.bankName')"
              :trackBy="'label'"
              :label="$t('setting.list.company.form.bankName')"
              :optionsGetter="resourcefulQuery.bankName"
              :optionLabelFn="({ item }) => item.label"
              :fullObject="fullObject.bankName"
              :multiple="false"
              :taggable="false"
              tabIndex="0"
              validation-behavior="live"
              error-behavior="live"
              validation="required"
              help="required"
              :validation-messages="{
                required: $t('setting.list.company.formAlert.bankName'),
              }"
            />
          </div>
        </b-col>

        <b-col md="6">
          <div class="mb-3 form-group">
            <FormulateInput
              id="accountNo"
              name="accountNo"
              :label="$t('setting.list.company.form.bankNumber')"
              :placeholder="$t('setting.list.company.form.bankNumber')"
              :validation="[['required'], ['number'], ['unique', accNo]]"
              :validation-messages="{
                required: $t('setting.list.company.formAlert.bankNumber'),
                unique: $t('setting.list.company.formAlert.bankNUmberUnique'),
                number: `${$t('setting.list.company.form.bankNumber')} ${$t(
                  'global.validation.number'
                )}`,
              }"
              validation-behavior="live"
              error-behavior="live"
              help="required"
            />
          </div>
        </b-col>

        <b-col md="6">
          <div class="mb-3 form-group">
            <FormulateInput
              id="accountName"
              name="accountName"
              :label="$t('setting.list.company.form.bankAccountName')"
              :placeholder="$t('setting.list.company.placeholder.bankAccountName')"
              validation="required"
              :validation-messages="{
                required: $t('setting.list.company.formAlert.bankAccountName'),
              }"
              validation-behavior="live"
              error-behavior="live"
              help="required"
            />
          </div>
        </b-col>
      </b-row>

      <div class="form-check">
        <b-form-checkbox
          v-model="bankAccounts.isDefault"
          :value="true"
          :unchecked-value="false"
          :disabled="isChecked"
        >
          {{ $t('setting.list.company.form.setAsMainBank') }}
        </b-form-checkbox>
      </div>
    </FormulateForm>
    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
          <McButton
            variant="secondary"
            :text="$t('global.action.cancel')"
            class="me-2"
            @click="cancel()"
          />
          <McButton
            variant="primary"
            :text="$t('global.action.save')"
            :disabled="disabled"
            @click="handleSubmitForm"
          />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import { Helper } from '@/mixin/helper'
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  mixins: [Helper],

  props: {
    tData: {},
    resetModal: {},
    formEdit: {},
  },

  data() {
    return {
      bankAccounts: {
        bankName: null,
        accountName: null,
        accountNo: null,
        isDefault: false,
      },
      fullObject: {
        bankName: {},
      },
      isChecked: false,
      accNo: [],
      disabled: false,
    }
  },

  computed: {
    resourcefulQuery() {
      return {
        bankName: (opts) => {
          let data = [
            { label: 'Mandiri' },
            { label: 'BCA' },
            { label: 'BRI' },
            { label: 'BNI' },
            { label: 'BSI' },
          ]

          if (opts.search) data = data.filter((item) => this.isContains(opts.search, item.label))

          const result = {
            metadata: {
              total_count: data.length,
              page: 1,
            },
            data: {
              paginated_result: data,
            },
          }

          return result
        },
      }
    },
  },

  watch: {
    'bankAccounts.bankName': function (val) {
      if (val) {
        this.fullObject.bankName = {
          label: val,
        }
      }
    },
  },

  created() {
    this.accNo = this.tData.map((item) => item.accountNo)
  },

  methods: {
    handleSubmitForm() {
      this.$refs.bankAccountRef.formSubmitted()
    },
    toSaveBank(bankAccounts) {
      this.$emit('toSaveBank', bankAccounts)
    },
  },
}
</script>
